import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { GetServerSidePropsContext } from "next";
import { NextPage } from "next";
import PortfolioLanding from "components/pages/portfolio/Landing";
import { getServerSession } from "next-auth";
import { authOptions } from "pages/api/auth/[...nextauth]";

interface Props {
  isMobile: boolean;
}

const PortfolioNew: NextPage<Props> = ({ isMobile }) => {
  return <PortfolioLanding isMobile={isMobile} />;
};
export default PortfolioNew;

export async function getServerSideProps(context: GetServerSidePropsContext) {
  const { locale } = context;

  // 포트폴리오 있는 회원일 경우 메인 화면으로 redirect
  const session: any = await getServerSession(
    context.req,
    context.res,
    authOptions
  );

  const pfUser = await fetch(
    `${process.env.NEXTAUTH_URL}/api/auth/portfolio?email=${session?.user?.email}`
  );
  const status = pfUser.status;
  const isError = status === 500;
  const isHavePort = status === 200;
  const result = await pfUser.json();
  const PORT_ID = result?.PORT_ID;

  if (session && isHavePort && PORT_ID) {
    return {
      redirect: {
        destination: "/?type=portfolio",
        permanent: false,
      },
    };
  }

  return {
    props: {
      ...(await serverSideTranslations(locale as string, ["portfolio"])),
    },
  };
}
